import {
  ACTIONS_FOR_SUPPORT_NAMES,
  LEGAL_FRAMEWORK_AND_RISKS_NAMES,
  LIST_OF_RISKS_NAMES,
} from 'components/BusinessToolForm/Sections/LegalFrameworkAndRisks/utils/form';

const ACTIONS_INSTRUCTIONS = {
  [ACTIONS_FOR_SUPPORT_NAMES.ACTION]: {
    name: 'Етап',
    instruction:
      'Перелічіть усі обов’язкові юридичні процедури, пов’язані з діяльністю компанії. Визначте ключові юридичні процеси, подання документів або кроки, що є невід’ємною частиною виконання регуляторних вимог.',
    exampleOne: 'Отримати сертифікат безпеки сільськогосподарської техніки USDA',
    exampleTwo: 'Зареєструвати торговельну марку',
  },
  [ACTIONS_FOR_SUPPORT_NAMES.START_DATE]: {
    name: 'Кінцеві терміни',
    instruction: 'Укажіть поточний статус для кожної процедури та очікувані строки її завершення.',
    exampleOne: 'Травень 2024',
    exampleTwo: 'Лютий 2024',
  },
  [ACTIONS_FOR_SUPPORT_NAMES.EXPECTED_DEADLINE]: {
    name: 'Кінцеві терміни',
    instruction: 'Укажіть поточний статус для кожної процедури та очікувані строки її завершення.',
    exampleOne: 'Грудень 2024',
    exampleTwo: 'Серпень 2024',
  },
};

const RISKS_INSTRUCTIONS = {
  [LIST_OF_RISKS_NAMES.NAME]: {
    name: 'Назва ризику',
    instruction:
      'Визначте та чітко сформулюйте назву ризику. Переконайтеся, що вона є конкретною та релевантною контексту, а також точно описує характер ризику.',
    exampleOne: 'Коливання цін на сировину',
    exampleTwo: 'Коливання валютних курсів',
  },
  [LIST_OF_RISKS_NAMES.GROUP]: {
    name: 'Група ризику',
    instruction:
      'Стисло вкажіть групу ризику, зазначивши, чи йдеться про економічні, організаційні, ринкові, виробничо-технічні, юридичні або інші ризики.',
    exampleOne: 'Економічні ризики',
    exampleTwo: 'Економічні ризики',
  },
  [LIST_OF_RISKS_NAMES.NEGATIVE_IMPACT]: {
    name: 'Негативний вплив',
    instruction:
      'Опишіть негативні наслідки ризиків, підкресливши потенційні втрати, збої в діяльності та шкоду для репутації або операцій.',
    exampleOne:
      'Невизначений попит на сільськогосподарську техніку може впливати на дохід і прибутковість Agrotech через коливання цін на сільськогосподарську продукцію. Зростання цін може стримувати фермерів від інвестицій, тоді як зниження цін може вплинути на маржу та обсяги продажів Компанії.',
    exampleTwo:
      'Коливання валютних курсів впливають на вартість імпорту сировини й експортні доходи Компанії. Невигідні курси підвищують виробничі витрати й знижують рентабельність, тоді як вигідні курси можуть підвищити конкурентоспроможність, але водночас впливають на цінові стратегії.',
  },
  [LIST_OF_RISKS_NAMES.PREVENTION_MEASURES]: {
    name: 'Заходи запобігання',
    instruction:
      'Почніть з огляду конкретних заходів, які ваш проєкт упровадив для пом’якшення виявлених ризиків. Детально опишіть проактивні кроки щодо кожного ризику, зокрема диверсифікацію ризиків, використання страхування, формування резервних фондів або створення стратегічних партнерств.',
    exampleOne:
      'Компанія може диверсифікувати продуктову лінійку, інвестувати в дослідження для здешевлення виробництва, укладати довгострокові контракти з постачальниками та впроваджувати гнучкі цінові стратегії.',
    exampleTwo:
      'Компанія може хеджувати ризики за допомогою фінансових інструментів, диверсифікувати клієнтську базу за регіонами, локалізувати виробництво для зменшення залежності від імпорту та укладати довгострокові контракти в стабільних валютах.',
  },
};

export const LEGAL_FRAMEWORKS_AND_RISKS_SECTION_INSTRUCTIONS = {
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.GENERAL_LAWS]: {
    name: 'Загальні закони та регуляції',
    instruction:
      'Укажіть юрисдикцію, у якій працює ваша компанія, і перелічіть закони та регуляції, що її регулюють. До переліку можуть входити корпоративне право, трудове й податкове законодавство. Забезпечте відповідність, посилаючись на релевантні акти та кодекси, щоб гарантувати законну діяльність у межах зазначеної юрисдикції.',
    exampleOne:
      'Компанія здійснює діяльність у США та підпадає під дію різних законів і регуляцій, включно з Податковим кодексом США (Internal Revenue Code) для податкової звітності, Законом про справедливі стандарти праці (Fair Labor Standards Act) для регулювання праці та Законом про цінні папери 1933 року (Securities Act of 1933) для корпоративного управління.',
    exampleTwo:
      'Компанія працює в юрисдикції штату Каліфорнія, США. Діяльність компанії регулюється California Corporations Code, California Labor Code та California Revenue and Taxation Code. Дотримання цих норм забезпечує законну роботу в межах визначеної юрисдикції.',
  },
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.INDUSTRY_REQUIREMENTS]: {
    name: 'Специфічні вимоги галузі',
    instruction:
      'Опишіть галузеві закони, яких має дотримуватися ваша компанія. Уточніть ліцензії, сертифікати або дозволи, необхідні для відповідності вимогам. Забезпечте чіткість і точність у викладенні цих вимог.',
    exampleOne:
      'Компанія дотримується галузевих законів, таких як Agricultural Improvement Act of 2018 (Farm Bill), що регулює сільське господарство. Додатково компанія має сертифікати ISO 9001, Emission Standards Compliance Certificate та USDA Agricultural Equipment Safety Certification.',
    exampleTwo:
      'Компанія повинна дотримуватися галузевих законів, таких як Translation and Interpreting Services Act у сфері мовних послуг. Відповідність вимагає отримання ліцензій American Translators Association та International Association of Professional Translators and Interpreters.',
  },
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.LEGAL_REQUIREMENTS]: {
    name: 'Відповідність юридичним вимогам',
    instruction:
      'Оцініть поточний стан відповідності компанії юридичним вимогам до ведення бізнесу. Визначте прогалини або недоліки та запропонуйте план коригувальних дій для повного дотримання регуляторних стандартів.',
    exampleOne:
      'Компанія наразі відповідає юридичним вимогам. Для усунення прогалин Компанія проходить процедуру отримання USDA Agricultural Equipment Safety Certification, і всі необхідні документи вже подано до Департаменту сертифікації США.',
    exampleTwo:
      'Компанія виконує всі юридичні вимоги для ведення бізнесу, включно з регуляціями у сфері мовних послуг, ліцензуванням, сертифікаціями та дозволами у відповідних юрисдикціях.',
  },
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.LIST_OF_ACTIONS]: ACTIONS_INSTRUCTIONS,
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.LIST_OF_RISKS]: RISKS_INSTRUCTIONS,
};
